(function () {
  'use strict';

  if (document.documentElement.getAttribute('data-hyde-cro-perf') !== '1') return;

  /* App embeds (Translate, KwikPass widgets) inject via content_for_header — cannot disable per template in Liquid.
     Push non-critical widget paint until after load to reduce early main-thread contention with PDP scripts. */
  document.documentElement.classList.add('rabitat-hyde-cro-defer-widgets');

  function revealWidgets() {
    document.documentElement.classList.remove('rabitat-hyde-cro-defer-widgets');
  }

  window.addEventListener(
    'load',
    function () {
      window.setTimeout(revealWidgets, 4000);
    },
    { once: true }
  );

  ['scroll', 'pointerdown'].forEach(function (eventName) {
    window.addEventListener(eventName, revealWidgets, { passive: true, once: true });
  });
})();
